import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon(React.createElement("path", {
  d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');